import { BackendUserRole } from "../constants";

export const isAdminRole = (roles: RoleType[], chainId: number) =>
  roles.some(
    (role) =>
      (role.chainId === chainId || role.chainId === null) && // for masterchain exception
      (role.role.name === BackendUserRole.SUPER_ADMIN ||
        role.role.name === BackendUserRole.ADMIN)
  );
